import React, { Component } from 'react';
import _ from 'lodash';
import {
    getcartitems,
    cartItemDelete,
    handlecheckCartonAPI,
    handlecheckFinalCartonAPI,
    updateitem,
    submitOrder,
    getbuyercartforadmin,
    getupdatedcartitemsofbuyerforadmin,
    finalOrderPrice,
    saveOrderComment,
    getOrderDiscountInfoCategoryWise,
} from '../../api/order';
import {
    getbuyercartofspecificorder,
    updatespecificorder,
    deletespecificorder,
    submitSpecificOrder,
} from '../../api/specificOrder';
import * as Order from '../../store/allStates/order/actions';
import { DISCOUNT_TYPES } from '../../../configs/constant';
const { type, saurbhiToast, saurbhiBounce } = require('../../../configs/constant');
class AbstractMyCart extends Component<any, any> {
    sign = React.createRef();
    constructor(props: any) {
        super(props);
        this.state = {
            isAddAnother: false,
            sign_uri: '',
            isShowNameError: false,
            isShowSignError: false,
            isShowAgreeError: false,
            showPlaceOrderDialog: false,
            isSignOrder: false,
            name: '',
            menuopened: false,
            field: '',
            selectedIndex: 0,
            selectedX: 0,
            selectedY: 0,
            last: '',
            cur: '0',
            finalCur: '0',
            order_price_Cal: '0',
            cartId: '',
            user_id: '',
            editFlag: true,
            successAddAlert: false,
            productDataArray: [],
            comment: '',
            totalPage: 0,
            totalcount: 0,
            pageLimit: 20,
            filter: {
                pageNo: 1,
                limit: 20,
            },
            itemList: [],
            isLoadingDisplay: false,
            id: '',
            deleteAlert: false,
            successDeleteAlert: false,
            errorAlert: false,
            responseMessage: '',
            editState: false,
            isItemAvailable: true,
            isItemAvailableError: '',
            isEditLoadingDisplay: false,
            index: null,
            successUpdateAlert: false,
            editItemModal: false,
            editNC: '',
            editTQ: '',
            editId: '',
            editSlug: '',
            editPC: '',
            editOP: '',
            editCP: '',
            discount: '',
            total_price: '',
            keyIndex: null,
            editIndex: null,
            dialogVisible: false,
            confirmAlert: false,
            editRecord: false,
            isNavigate: false,
            no_of_carton_calc: false,
            total_quantity_calc: false,
            discount_calc: false,
            price_calc: false,
            order_price_calc: false,
            calculatorOpenInputFieldIndex: null,
            signatureModal: false,
            isModalLoadingDisplay: false,
            acceptTNC: false,
            signatureFile: null,
            signatureName: '',
            specificUnpaidFlag: false,
            specificUserId: '',
            specificOrderId: '',
            revokedDiscountProducts: [],
            revokedDiscountProductsModal: false,
            flatOfferDiscountInfo: [],
            isFlatOfferProductInCart: false,
            isBuyGetOfferProductInCart: false,
            isBuyGetRecurringProductInCart: false,
            buyGetOfferDiscountInfo: [],
            buyGetRecurringDiscountInfo: [],
            offerLoading: false,
            popoverOpen: {
                'flat-offer': false,
                'buy-get-offer': false,
                'buy-get-recurring-offer': false,
            },
        };
    }

    saveOrderComment = () => {
        this.setState({ isEditLoadingDisplay: true }, () => {
            let sentObj = {
                comment: this.state.comment,
            };
            let orderid = localStorage.getItem('orderid');
            if (orderid && orderid !== undefined && orderid !== null && orderid !== '') {
                this.props
                    .dispatch(saveOrderComment(orderid, sentObj))
                    .then((res: any) => {
                        this.setState({ isEditLoadingDisplay: false });
                    })
                    .catch((error: any) => {
                        this.setState({
                            isEditLoadingDisplay: false,
                            errorAlert: true,
                            responseMessage: error.error.message,
                        });
                    });
            } else {
                this.setState({
                    isEditLoadingDisplay: false,
                    errorAlert: true,
                    responseMessage: 'Order id not found',
                });
            }
        });
    };

    setPopoverOpen = (id:any) => {
        this.setState({ popoverOpen: { ...this.state.popoverOpen, [id]: !this.state.popoverOpen[id] } });
    }

    offerInfoDetails = (categoryId: string) => {
        this.props
            .dispatch(getOrderDiscountInfoCategoryWise(categoryId, this.props.cart.cartItems[0].order_id))
            .then((response: any) => {
                const allOfferProducts = _.groupBy(response.data, 'discount_type');
                let flatInfo = allOfferProducts[DISCOUNT_TYPES.FLAT] ? allOfferProducts[DISCOUNT_TYPES.FLAT] : [];
                let buyGetInfo = allOfferProducts[DISCOUNT_TYPES.BUY_GET]
                    ? allOfferProducts[DISCOUNT_TYPES.BUY_GET]
                    : [];
                let buyGetRecurringInfo = allOfferProducts[DISCOUNT_TYPES.BUY_GET_RECURRING]
                    ? allOfferProducts[DISCOUNT_TYPES.BUY_GET_RECURRING]
                    : [];
                const fn = async () => {
                    return await this.props.cart.cartItems.map((item: any) => item.product_item_id);
                };
                fn()
                    .then((d) => {
                        const cartItemsSet = new Set(d);
                        const flatProductExistInCart = flatInfo.some((element) =>
                            cartItemsSet.has(element.product_item_id),
                        );
                        const buyGetProductExistInCart = buyGetInfo.some((element) =>
                            cartItemsSet.has(element.product_item_id),
                        );
                        const buyGetRecurringProductExistInCart = buyGetRecurringInfo.some((element) =>
                            cartItemsSet.has(element.product_item_id),
                        );
                        this.setState({
                            isFlatOfferProductInCart: flatProductExistInCart,
                            isBuyGetOfferProductInCart: buyGetProductExistInCart,
                            isBuyGetRecurringProductInCart: buyGetRecurringProductExistInCart,
                            flatOfferDiscountInfo: flatInfo,
                            buyGetOfferDiscountInfo: buyGetInfo,
                            buyGetRecurringDiscountInfo: buyGetRecurringInfo,
                            offerLoading: false,
                        });
                    })
                    .catch((e: any) => {
                        console.error('cart has no items');
                    });
            })
            .catch((error: any) => {
                this.setState({
                    flatOfferDiscountInfo: [],
                    buyGetOfferDiscountInfo: [],
                    buyGetRecurringDiscountInfo: [],
                    offerLoading: false,
                });
            });
    };

    GetFinalPriceOrder = (id: any) => {
        this.setState({ isEditLoadingDisplay: true }, () => {
            this.props
                .dispatch(finalOrderPrice(id))
                .then((res: any) => {
                    this.setState({ signatureModal: true, isEditLoadingDisplay: false });
                })
                .catch((error: any) => {
                    this.setState({
                        isEditLoadingDisplay: false,
                        errorAlert: true,
                        responseMessage: error.error.message,
                    });
                });
        });
    };

    toggleSignatureModal = () => {
        this.setState((prevState: any) => ({
            signatureModal: !prevState.signatureModal,
            acceptTNC: false,
            signatureFile: null,
            signatureName: '',
            comment: '',
        }));
    };

    acceptTNC = (accept: any) => {
        this.setState({
            acceptTNC: accept,
        });
    };

    takeSnapShot = (file: any) => {
        this.setState({
            signatureFile: file,
        });
    };

    signatureName = (value: any) => {
        this.setState({
            signatureName: value,
        });
    };

    handleOrderPrice = (e: any, id: any) => {
        let UserType = localStorage.getItem('user_type');
        let newData;
        if (UserType === type.buyer.toString()) {
            newData = [...this.state.itemList];
        } else {
            newData = [...this.props.cart.cartItems];
        }
        const rowIndex = newData.findIndex((x: any) => x._id === id);
        newData[rowIndex]['order_price'] = e.target.value.trim().replace(/[^0-9.]/gi, '');
        this.setState({
            itemList: newData,
            editOP: e.target.value.trim().replace(/[^0-9.]/gi, ''),
            currentIndex: rowIndex,
        });
    };

    handleChangeComment = (e: any) => {
        this.setState({ comment: e.target.value });
    };

    handleChangeFractions = (text: any) => {
        if (text !== '') {
            return parseFloat(text).toFixed(4);
        }
    };

    handleCarton = async (e: any, id: any) => {
        var UserType: any = localStorage.getItem('user_type');
        let newData;
        if (UserType === type.buyer.toString()) {
            newData = [...this.state.itemList];
        } else {
            newData = [...this.props.cart.cartItems];
        }
        const rowIndex = newData.findIndex((x: any) =>
            UserType !== type.buyer.toString() ? x._id === id : x.item_id === id,
        );
        newData[rowIndex]['no_of_carton'] = e.target.value.trim().replace(/[^0-9]/gi, '');
        newData[rowIndex]['is_carton_used'] = true;
        newData[rowIndex]['is_quantity_used'] = false;
        this.setState(
            {
                itemList: newData,
                editNC: e.target.value.trim().replace(/[^0-9]/gi, ''),
            },
            () => {
                //this.checkCartonAPI(this.state.editIndex);
            },
        );
    };

    checkCartonAPI = _.debounce(async (index) => {
        if (this.state.itemList.length > 0) {
            if (this.state.editNC !== '') {
                let credentials = {
                    slug: this.state.itemList[index].items && this.state.itemList[index].items.slug,
                    carton: this.state.editNC,
                    order_price: this.state.itemList[index].order_price,
                    discount: this.state.itemList[index].discount,
                };
                this.setState({ isEditLoadingDisplay: true });
                this.props
                    .dispatch(handlecheckCartonAPI(credentials))
                    .then((res: any) => {
                        let newData = [...this.state.itemList];
                        newData[index]['total_quantity'] = res.data;
                        newData[index]['total_price'] = res.priceData;

                        this.setState({
                            editTQ: res.data,
                            total_price: res.priceData,
                            editNC: parseFloat(this.state.editNC).toFixed(4),
                            itemList: newData,
                            isItemAvailable: true,
                            isItemAvailableError: '',
                            isEditLoadingDisplay: false,
                        });
                    })
                    .catch((error: any) => {
                        let newData = [...this.state.itemList];
                        newData[index]['total_quantity'] = '';
                        newData[index]['total_price'] = '';
                        this.setState({
                            editTQ: '',
                            isItemAvailable: false,
                            isItemAvailableError: error.error.message,
                            responseMessage: error.error.message,
                            isEditLoadingDisplay: false,
                        });
                        saurbhiToast.error(error.error.message, {
                            transition: saurbhiBounce,
                            position: saurbhiToast.POSITION.TOP_CENTER,
                        });
                    });
            } else {
                let newData = [...this.state.itemList];
                newData[index]['total_quantity'] = '';
                newData[index]['total_price'] = '';
                this.setState({
                    editTQ: '',
                    isItemAvailable: false,
                });
            }
        }
    }, 1);

    checkFinalCartonAPI = _.debounce(async (index) => {
        if (this.state.itemList.length > 0) {
            if (this.state.editNC !== '') {
                let credentials = {
                    slug: this.state.itemList[index].items && this.state.itemList[index].items.slug,
                    carton: this.state.editNC,
                    order_price: this.state.itemList[index].order_price,
                    discount: this.state.itemList[index].discount,
                };
                this.setState({ isEditLoadingDisplay: true });
                this.props
                    .dispatch(handlecheckFinalCartonAPI(credentials))
                    .then((res: any) => {
                        let newData = [...this.state.itemList];
                        newData[index]['total_quantity'] = res.data;
                        newData[index]['total_price'] = res.priceData;

                        this.setState({
                            editTQ: res.data,
                            total_price: res.priceData,
                            editNC: parseFloat(this.state.editNC).toFixed(4),
                            itemList: newData,
                            isItemAvailable: true,
                            isItemAvailableError: '',
                            isEditLoadingDisplay: false,
                        });
                    })
                    .catch((error: any) => {
                        let newData = [...this.state.itemList];
                        newData[index]['total_quantity'] = '';
                        newData[index]['total_price'] = '';
                        this.setState({
                            editTQ: '',
                            isItemAvailable: false,
                            isItemAvailableError: error.error.message,
                            responseMessage: error.error.message,
                            isEditLoadingDisplay: false,
                        });
                        saurbhiToast.error(error.error.message, {
                            transition: saurbhiBounce,
                            position: saurbhiToast.POSITION.TOP_CENTER,
                        });
                    });
            } else {
                let newData = [...this.state.itemList];
                newData[index]['total_quantity'] = '';
                newData[index]['total_price'] = '';
                this.setState({
                    editTQ: '',
                    isItemAvailable: false,
                });
            }
        }
    }, 1);

    handleQuantity = async (e: any, id: any) => {
        var UserType = localStorage.getItem('user_type');
        let newData;
        if (UserType === type.buyer.toString()) {
            newData = [...this.state.itemList];
        } else {
            newData = [...this.props.cart.cartItems];
        }
        const rowIndex = newData.findIndex((x: any) =>
            UserType !== type.buyer.toString() ? x._id === id : x.item_id === id,
        );
        newData[rowIndex]['total_quantity'] = e.target.value.trim().replace(/[^0-9.]/gi, '');
        newData[rowIndex]['is_quantity_used'] = true;
        newData[rowIndex]['is_carton_used'] = false;
        this.setState({
            itemList: newData,
            editTQ: e.target.value.trim().replace(/[^0-9.]/gi, ''),
        });
    };

    checkQauntityAPI = _.debounce(async (index) => {
        if (this.state.itemList.length > 0) {
            if (this.state.editTQ !== '') {
                let credentials = {
                    slug: this.state.itemList[index].items && this.state.itemList[index].items.slug,
                    quantity: this.state.editTQ,
                    order_price: this.state.itemList[index].order_price,
                    discount: this.state.itemList[index].discount,
                };
                this.setState({ isEditLoadingDisplay: true });
                this.props
                    .dispatch(handlecheckCartonAPI(credentials))
                    .then((res: any) => {
                        let newData = [...this.state.itemList];
                        newData[index]['no_of_carton'] = parseFloat(res.data).toFixed(4);
                        newData[index]['total_price'] = res.priceData;
                        this.setState({
                            total_price: res.priceData,
                            editNC: parseFloat(res.data).toFixed(4),
                            itemList: newData,
                            isItemAvailable: true,
                            isItemAvailableError: '',
                            isEditLoadingDisplay: false,
                        });
                    })
                    .catch((error: any) => {
                        let newData = [...this.state.itemList];
                        newData[index]['no_of_carton'] = '';
                        newData[index]['total_price'] = '';
                        this.setState({
                            itemList: newData,
                            editNC: '',
                            isItemAvailable: false,
                            isItemAvailableError: error.error.message,
                            responseMessage: error.error.message,
                            isEditLoadingDisplay: false,
                        });
                        saurbhiToast.error(error.error.message, {
                            transition: saurbhiBounce,
                            position: saurbhiToast.POSITION.TOP_CENTER,
                        });
                    });
            } else {
                let newData = [...this.state.itemList];
                newData[index]['no_of_carton'] = '';
                newData[index]['total_price'] = '';
                this.setState({
                    itemList: newData,
                    editNC: '',
                    isItemAvailable: false,
                });
            }
        }
    }, 1);

    handleDiscount = async (e: any, id: any) => {
        var UserType = localStorage.getItem('user_type');
        let newData;
        if (UserType === type.buyer.toString()) {
            newData = [...this.state.itemList];
        } else {
            newData = [...this.props.cart.cartItems];
        }
        const rowIndex = newData.findIndex((x: any) => x._id === id);
        newData[rowIndex]['discount'] = e.target.value.trim().replace(/[^0-9.]/gi, '');
        this.setState(
            {
                itemList: newData,
                discount: e.target.value.trim().replace(/[^0-9.]/gi, ''),
            },
            // () => {
            //   this.checkDiscountAPI(rowIndex);
            // }
        );
    };

    checkDiscountAPI = _.debounce(async (index) => {
        if (this.state.itemList.length > 0) {
            var UserType = localStorage.getItem('user_type');
            let credentials = {};
            if (UserType !== type.buyer.toString()) {
                credentials = {
                    slug: this.state.itemList[index].items && this.state.itemList[index].items.slug,
                    carton: this.state.itemList[index].no_of_carton,
                    quantity: this.state.itemList[index].quantity,
                    discount: this.state.itemList[index].discount,
                    order_price: this.state.itemList[index].order_price,
                    user_id: this.state.CustomerId,
                };
            } else {
                credentials = {
                    slug: this.state.itemList[index].items && this.state.itemList[index].items.slug,
                    carton: this.state.itemList[index].no_of_carton,
                    quantity: this.state.itemList[index].quantity,
                    discount: this.state.itemList[index].discount,
                    order_price: this.state.itemList[index].order_price,
                };
            }
            if (
                this.state.itemList[index].no_of_carton !== '' &&
                this.state.itemList[index].quantity !== '' &&
                this.state.itemList[index].discount !== ''
            ) {
                this.setState({ isEditLoadingDisplay: true });
                this.props
                    .dispatch(handlecheckFinalCartonAPI(credentials))
                    .then((res: any) => {
                        let newData = [...this.state.itemList];
                        newData[index]['total_price'] = res.priceData;
                        this.setState({ itemList: newData, total_price: res.priceData }, () => {
                            this.setState({
                                isItemAvailable: true,
                                isItemAvailableError: '',
                                isEditLoadingDisplay: false,
                            });
                        });
                    })
                    .catch((error: any) => {
                        let newData = [...this.state.itemList];
                        newData[index]['total_price'] = '';
                        this.setState({ itemList: newData, total_price: '' }, () => {
                            this.setState({
                                isItemAvailable: false,
                                isItemAvailableError: error.error.message,
                                responseMessage: error.error.message,
                                isEditLoadingDisplay: false,
                            });
                            saurbhiToast.error(error.error.message, {
                                transition: saurbhiBounce,
                                position: saurbhiToast.POSITION.TOP_CENTER,
                            });
                        });
                    });
            }
        }
    }, 1);

    checkCartonPriceAPI = _.debounce(async (index) => {
        if (this.state.itemList.length > 0) {
            let newData = [...this.state.itemList];
            newData[index]['carton_price'] = (newData[index].product_per_carton * newData[index].order_price).toFixed(
                4,
            );
            this.setState(
                {
                    itemList: newData,
                    editCP: (newData[index].product_per_carton * newData[index].order_price).toFixed(4),
                },
                () => {
                    this.checkFinalCartonAPI(index);
                },
            );
        }
    }, 1);

    handlePrice = async (e: any, id: any) => {
        var UserType = localStorage.getItem('user_type');
        let newData;
        if (UserType === type.buyer.toString()) {
            newData = [...this.state.itemList];
        } else {
            newData = [...this.props.cart.cartItems];
        }
        const rowIndex = newData.findIndex((x: any) => x._id === id);
        newData[rowIndex]['total_price'] = e.target.value.trim().replace(/[^0-9.]/gi, '');
        this.setState(
            {
                itemList: newData,
                total_price: e.target.value.trim().replace(/[^0-9.]/gi, ''),
            },
            // () => {
            //   this.checkPriceAPI(rowIndex);
            // }
        );
    };

    checkPriceAPI = _.debounce(async (index) => {
        if (this.state.itemList.length > 0) {
            var UserType = localStorage.getItem('user_type');
            let credentials = {};
            if (UserType !== type.buyer.toString()) {
                credentials = {
                    slug: this.state.itemList[index].items && this.state.itemList[index].items.slug,
                    carton: this.state.itemList[index].no_of_carton,
                    quantity: this.state.itemList[index].quantity,
                    price: this.state.itemList[index].total_price,
                    order_price: this.state.itemList[index].order_price,
                    discount: this.state.itemList[index].discount,
                    user_id: this.state.CustomerId,
                };
            } else {
                credentials = {
                    slug: this.state.itemList[index].items && this.state.itemList[index].items.slug,
                    carton: this.state.itemList[index].no_of_carton,
                    quantity: this.state.itemList[index].quantity,
                    price: this.state.itemList[index].total_price,
                    order_price: this.state.itemList[index].order_price,
                };
            }
            if (
                this.state.itemList[index].no_of_carton !== '' &&
                this.state.itemList[index].quantity !== '' &&
                this.state.itemList[index].total_price !== ''
            ) {
                this.setState({ isEditLoadingDisplay: true });
                this.props
                    .dispatch(handlecheckFinalCartonAPI(credentials))
                    .then((res: any) => {
                        let newData = [...this.state.itemList];
                        newData[index]['discount'] = res.discount;
                        this.setState({ itemList: newData, discount: res.discount }, () => {
                            this.setState({
                                isItemAvailable: true,
                                isItemAvailableError: '',
                                isEditLoadingDisplay: false,
                            });
                        });
                    })
                    .catch((error: any) => {
                        let newData = [...this.state.itemList];
                        newData[index]['discount'] = '';
                        this.setState({ itemList: newData, discount: '' }, () => {
                            this.setState({
                                isItemAvailable: false,
                                isItemAvailableError: error.error.message,
                                responseMessage: error.error.message,
                                isEditLoadingDisplay: false,
                            });
                            saurbhiToast.error(error.error.message, {
                                transition: saurbhiBounce,
                                position: saurbhiToast.POSITION.TOP_CENTER,
                            });
                        });
                    });
            }
        }
    }, 1);

    async componentDidUpdate(prevProps: any, prevState: any) {
        let cartId;
        let itemList = this.state.itemList;
        var UserType = localStorage.getItem('user_type');
        if (this.props.cart.cartItems && this.props.cart.cartItems.length > 0) {
            cartId = this.props.cart.cartItems[0] && this.props.cart.cartItems[0].order_id;
            if (cartId !== prevState.cartId) {
                this.setState({ cartId });
            }
            itemList = this.props.cart.cartItems;
            if (this.props.cart.cartItems !== prevState.itemList) {
                if (
                    UserType === type.admin.toString() ||
                    UserType === type.officeAdmin.toString() ||
                    UserType === type.salesman.toString()
                ) {
                    this.props.cart.cartItems.map((data: any) => (data.slug = data.items.slug));
                }
            }
        }
        if (
            (UserType === type.admin.toString() ||
                UserType === type.officeAdmin.toString() ||
                UserType === type.salesman.toString()) &&
            itemList.length > 0
        ) {
            cartId = itemList[0] && itemList[0].order_id;
            if (cartId !== prevState.cartId) {
                this.setState({ cartId });
            }
        } else {
            UserType = localStorage.getItem('user_type');
            let cartId;
            let itemList = this.state.itemList;
            if (this.props.cart.cartItems && this.props.cart.cartItems.length > 0) {
                itemList = this.props.cart.cartItems;
                if (this.props.cart.cartItems !== prevState.itemList) {
                    if (UserType === type.admin.toString() || UserType === type.officeAdmin.toString()) {
                        this.props.cart.cartItems.map((data: any) => (data.slug = data.items.slug));
                    }
                    this.setState({ itemList: this.props.cart.cartItems });
                }
            }
            if (
                (UserType === type.admin.toString() || UserType === type.officeAdmin.toString()) &&
                itemList.length > 0
            ) {
                cartId = itemList[0] && itemList[0].cartId;
                if (cartId !== prevState.cartId) {
                    this.setState({ cartId });
                }
            }
            const { filter } = this.state;
            if (filter !== prevState.filter) {
                this.setState({ isLoadingDisplay: true }, () => {
                    this.GetCartItemList(filter);
                });
            }
        }
    }

    componentDidMount() {
        let UserType = localStorage.getItem('user_type');
        if (UserType === type.buyer.toString()) {
            this.setState({ isEditLoadingDisplay: true }, () => {
                this.GetCartItemList();
            });
        }
    }

    GetCartItemList = (newfilter?: any) => {
        this.props
            .dispatch(getcartitems(newfilter))
            .then(async (res: any) => {
                this.setState({
                    itemList: res.data.rows,
                    totalPage: res.data.totalPage,
                    totalcount: res.data.count,
                    pageLimit: res.data.limit,
                    isEditLoadingDisplay: false,
                });
            })
            .catch((error: any) => {
                this.setState({
                    totalPage: 0,
                    totalcount: 0,
                    pageLimit: 20,
                    itemList: [],
                    isEditLoadingDisplay: false,
                    dialogVisible: true,
                });
            });
    };

    GetUpdatedCartItemListOfBuyerForAdmin = (newfilter: any) => {
        this.props
            .dispatch(getupdatedcartitemsofbuyerforadmin(newfilter))
            .then(async (res: any) => {
                let data = [...res.data.rows[0].order_details];
                let order = {
                    user_id: res.data.rows[0].user_id,
                };
                data.map((value, i) => (value.order = order));
                this.setState({
                    itemList: data,
                    totalPage: res.data.totalPage,
                    totalcount: res.data.count,
                    pageLimit: res.data.limit,
                    isEditLoadingDisplay: false,
                });
            })
            .catch((error: any) => {
                this.setState({
                    totalPage: 0,
                    totalcount: 0,
                    pageLimit: 20,
                    itemList: [],
                    isEditLoadingDisplay: false,
                    dialogVisible: true,
                });
            });
    };

    GetBuyerCartForAdmin = (newfilter: any) => {
        this.props
            .dispatch(getbuyercartforadmin(newfilter))
            .then(async (res: any) => {
                let data = [...res.data.rows[0].order_details];
                let order = {
                    user_id: res.data.rows[0].user_id,
                };
                data.map((value, i) => (value.order = order));
                this.setState({
                    itemList: data,
                    totalPage: res.data.totalPage,
                    totalcount: res.data.count,
                    pageLimit: res.data.limit,
                    isEditLoadingDisplay: false,
                });
            })
            .catch((error: any) => {
                this.setState({
                    totalPage: 0,
                    totalcount: 0,
                    pageLimit: 20,
                    itemList: [],
                    isEditLoadingDisplay: false,
                    responseMessage: error.error.message,
                });
            });
    };

    GetSpecificCartDetails = (filter: any) => {
        this.props
            .dispatch(getbuyercartofspecificorder(filter))
            .then(async (res: any) => {
                this.setState({
                    itemList: res.data.rows[0].order_details,
                    totalPage: res.data.totalPage,
                    totalcount: res.data.count,
                    pageLimit: res.data.limit,
                    isEditLoadingDisplay: false,
                });
            })
            .catch((error: any) => {
                this.setState({
                    isNavigate: true,
                    totalPage: 0,
                    totalcount: 0,
                    pageLimit: 20,
                    itemList: [],
                    responseMessage: error.error.message,
                    isEditLoadingDisplay: false,
                    dialogVisible: true,
                });
            });
    };

    handlePageChange = (data: any) => {
        let selectPage = data.selected + 1;
        this.setState((prevState: any) => {
            let filter = Object.assign({}, prevState.filter);
            filter.pageNo = selectPage;
            return { filter };
        });
    };

    handleSubmitDeleteAPI = async () => {
        let filter = this.state.filter;
        let UserType = localStorage.getItem('user_type');
        let url = this.props.location.pathname.split('/')[3];
        if (url !== 'specific-order' && url !== 'specific-order-cart-list') {
            this.setState({ deleteAlert: false, isEditLoadingDisplay: true }, () => {
                let credentials = {
                    is_buyer:
                        UserType === type.admin.toString() ||
                        UserType === type.officeAdmin.toString() ||
                        UserType === type.salesman.toString()
                            ? false
                            : true,
                };
                this.props
                    .dispatch(cartItemDelete(this.state.id, this.state.user_id, credentials))
                    .then((res: any) => {
                        filter.user_id = this.state.user_id;
                        if (
                            UserType === type.admin.toString() ||
                            UserType === type.officeAdmin.toString() ||
                            UserType === type.salesman.toString()
                        ) {
                            let url = this.props.location.pathname.split('/')[3];
                            if (url === 'buyer-cart-list') {
                                filter.id = this.state.cartId;
                                this.GetUpdatedCartItemListOfBuyerForAdmin(filter);
                            } else {
                                filter.id = this.state.cartId;
                                this.GetBuyerCartForAdmin(filter);
                            }
                        } else {
                            let userFilter = {
                                user_id: this.state.user_id,
                            };
                            this.GetCartItemList(userFilter);
                        }
                        this.setState({
                            isEditLoadingDisplay: false,
                            responseMessage: res.message,
                            successDeleteAlert: true,
                            confirmAlert: false,
                        });
                    })
                    .catch((error: any) => {
                        this.setState({
                            isEditLoadingDisplay: false,
                            errorAlert: true,
                            responseMessage: error.error.message,
                            confirmAlert: false,
                        });
                    });
            });
        } else {
            this.setState({ deleteAlert: false, isEditLoadingDisplay: true }, () => {
                this.props
                    .dispatch(deletespecificorder(this.state.id))
                    .then((res: any) => {
                        filter.user_id = this.state.user_id;
                        if (
                            UserType === type.admin.toString() ||
                            UserType === type.officeAdmin.toString() ||
                            UserType === type.driver.toString()
                        ) {
                            this.GetSpecificCartDetails(filter);
                        }
                        this.setState({
                            isEditLoadingDisplay: false,
                            responseMessage: res.message,
                            successDeleteAlert: true,
                            confirmAlert: false,
                        });
                    })
                    .catch((error: any) => {
                        this.setState({
                            isEditLoadingDisplay: false,
                            errorAlert: true,
                            responseMessage: error.error.message,
                            confirmAlert: false,
                        });
                    });
            });
        }
    };

    handleUpdateItem = async (price_flag: any) => {
        let filter = this.state.filter;
        if (this.state.editNC !== '' && this.state.editTQ !== '' && this.state.isItemAvailable === true) {
            let credentials: any = {};
            var UserType = localStorage.getItem('user_type');
            credentials = {
                slug: this.state.editSlug,
                id: this.state.editId,
                product_per_carton: this.state.editPC,
                total_quantity: this.state.editTQ,
                no_of_carton: this.state.editNC,
                user_id: this.state.user_id,
                discount: this.state.discount,
                total_price: this.state.total_price,
                order_price: this.state.editOP,
                carton_price: this.state.editCP,
                price_flag,
            };

            let url = this.props.location.pathname.split('/')[3];
            if (url !== 'specific-order' && url !== 'specific-order-cart-list') {
                this.setState({ isEditLoadingDisplay: true }, () => {
                    this.props
                        .dispatch(updateitem(this.state.editId, credentials))
                        .then((res: any) => {
                            filter.user_id = this.state.user_id;
                            if (
                                UserType === type.admin.toString() ||
                                UserType === type.officeAdmin.toString() ||
                                UserType === type.salesman.toString()
                            ) {
                                let url = this.props.location.pathname.split('/')[3];
                                if (url === 'buyer-cart-list') {
                                    filter.id = this.state.cartId;
                                    this.GetUpdatedCartItemListOfBuyerForAdmin(filter);
                                } else {
                                    filter.id = this.state.cartId;
                                    this.GetBuyerCartForAdmin(filter);
                                }
                            } else {
                                let userFilter = {
                                    user_id: this.state.user_id,
                                };
                                this.GetCartItemList(userFilter);
                            }
                            this.setState({
                                successUpdateAlert: true,
                                responseMessage: res.message,
                                isEditLoadingDisplay: false,
                                editIndex: null,
                            });
                        })
                        .catch((error: any) => {
                            this.setState({
                                isEditLoadingDisplay: false,
                                errorAlert: true,
                                responseMessage: error.error.message,
                                editIndex: null,
                            });
                        });
                });
            } else {
                this.setState({ isEditLoadingDisplay: true }, () => {
                    this.props
                        .dispatch(updatespecificorder(this.state.editId, credentials))
                        .then((res: any) => {
                            filter.user_id = this.state.user_id;
                            if (UserType === type.admin.toString() || UserType === type.officeAdmin.toString()) {
                                this.GetSpecificCartDetails(filter);
                            }
                            this.setState({
                                successUpdateAlert: true,
                                responseMessage: res.message,
                                isEditLoadingDisplay: false,
                                editIndex: null,
                            });
                        })
                        .catch((error: any) => {
                            this.setState({
                                isEditLoadingDisplay: false,
                                errorAlert: true,
                                responseMessage: error.error.message,
                                editIndex: null,
                            });
                        });
                });
            }
        } else {
            saurbhiToast.error('Please enter all details of item', {
                transition: saurbhiBounce,
                position: saurbhiToast.POSITION.TOP_CENTER,
            });
        }
    };

    handleSubmitOrder = async (values: any) => {
        var UserType = localStorage.getItem('user_type');
        let newData: any;
        if (UserType === type.buyer.toString()) {
            let cartData = [...this.props.cart.cartItems];
            if (cartData.length > 0) {
                newData = [...this.props.cart.cartItems];
            } else {
                newData = [...this.state.itemList];
            }
        } else {
            newData = [...this.props.cart.cartItems];
        }
        let checkDeposit = newData.filter((x: any) => x.no_of_carton === undefined);

        if (checkDeposit.length > 0) {
            saurbhiToast.error('Please enter all items details', {
                transition: saurbhiBounce,
                position: saurbhiToast.POSITION.TOP_CENTER,
            });
        } else {
            let url = this.props.location.pathname.split('/')[3];
            if (url !== 'specific-order' && url !== 'specific-order-cart-list') {
                let orderid = localStorage.getItem('orderid');
                if (orderid && orderid !== undefined && orderid !== null && orderid !== '') {
                    this.setState({ comment: values.comment });
                    this.GetFinalPriceOrder(orderid);
                }
            } else {
                let UserType = localStorage.getItem('user_type');
                var CustomerId = localStorage.getItem('CustomerId');
                let newData: any;
                if (UserType === type.buyer.toString()) {
                    let cartData = [...this.props.cart.cartItems];
                    if (cartData.length > 0) {
                        newData = [...this.props.cart.cartItems];
                    } else {
                        newData = [...this.state.itemList];
                    }
                } else {
                    newData = [...this.props.cart.cartItems];
                }
                this.setState({ isEditLoadingDisplay: true }, async () => {
                    let selectedFinItems: any = [];
                    if (newData.length > 0) {
                        newData.forEach((v: any) => {
                            selectedFinItems.push({
                                product_item_id: v.product_item_id,
                                order_details_id: v.id,
                            });
                        });
                    }
                    let credentials = {
                        comment: this.state.comment,
                        cart: JSON.stringify(selectedFinItems),
                        user_id: CustomerId,
                    };
                    this.props
                        .dispatch(submitSpecificOrder(credentials))
                        .then((res: any) => {
                            this.setState({
                                isEditLoadingDisplay: false,
                                responseMessage: res.message,
                                successAddAlert: true,
                                itemList: [],
                                specificUnpaidFlag: res.data.anyUnpaidOrderExists,
                                specificUserId: res.data.user_id,
                                comment: '',
                            });
                            if (!res.data.anyUnpaidOrderExists) {
                                let data = [];
                                data.push({
                                    id: res.data.order_id,
                                    gross_amount: res.data.total,
                                });
                                localStorage.setItem('unpaidArray', JSON.stringify(data));
                            }
                            this.props.dispatch(Order.cart([]));
                        })
                        .catch((error: any) => {
                            this.setState({
                                isEditLoadingDisplay: false,
                                errorAlert: true,
                                responseMessage: error.error.message,
                                comment: '',
                            });
                        });
                });
            }
        }
    };

    handleSubmitWithSignature = async () => {
        var UserType = localStorage.getItem('user_type');
        var CustomerId = localStorage.getItem('CustomerId');
        let newData: any;
        if (UserType === type.buyer.toString()) {
            let cartData = [...this.props.cart.cartItems];
            if (cartData.length > 0) {
                newData = [...this.props.cart.cartItems];
            } else {
                newData = [...this.state.itemList];
            }
        } else {
            newData = [...this.props.cart.cartItems];
        }
        this.setState({ isModalLoadingDisplay: true }, async () => {
            let selectedFinItems: any = [];
            if (newData.length > 0) {
                newData.forEach((v: any) => {
                    selectedFinItems.push({
                        product_item_id: v.product_item_id,
                        order_details_id: UserType !== type.buyer.toString() ? v._id : v.item_id,
                    });
                });
            }
            const credentials = new FormData();
            if (CustomerId) {
                credentials.append('comment', this.state.comment);
                credentials.append('cart', JSON.stringify(selectedFinItems));
                credentials.append('digital_sign_name', this.state.signatureName);
                credentials.append('digital_sign', this.state.signatureFile);
                credentials.append('user_id', CustomerId);
            } else {
                credentials.append('comment', this.state.comment);
                credentials.append('cart', JSON.stringify(selectedFinItems));
                credentials.append('digital_sign_name', this.state.signatureName);
                credentials.append('digital_sign', this.state.signatureFile);
                credentials.append('user_id', '');
            }
            this.props
                .dispatch(submitOrder(credentials))
                .then((res: any) => {
                    //revokedDiscount
                    this.setState({
                        isModalLoadingDisplay: false,
                        responseMessage: res.message,
                        productDataArray: res.productDataArray,
                        successAddAlert: true,
                        itemList: [],
                        revokedDiscountProductsModal: res?.revokedDiscount?.length > 0 ? true : false,
                        revokedDiscountProducts: res.revokedDiscount
                            ? res.revokedDiscount
                            : this.state.revokedDiscountProducts,
                    });
                    localStorage.removeItem('orderid');
                    this.props.dispatch(Order.cart([]));
                    this.toggleSignatureModal();
                })
                .catch((error: any) => {
                    this.toggleSignatureModal();
                    this.setState({
                        isModalLoadingDisplay: false,
                        errorAlert: true,
                        responseMessage: error.error.message,
                        productDataArray: error.error.productDataArray,
                        revokedDiscountProducts: [],
                    });
                });
        });
    };

    closeModalForBuyer = () => {
        this.setState({ editIndex: null, comment: '' });
        // let { filter } = this.state;
        let UserType = localStorage.getItem('user_type');
        if (UserType === type.buyer.toString()) {
            this.setState({ itemList: [], isEditLoadingDisplay: true }, () => {
                this.GetCartItemList();
            });
        } else {
            this.props.dispatch(Order.cart([]));
        }
    };
}
export default AbstractMyCart;
